module.exports = __webpack_public_path__ + "media/src/img/payment/balance-90042c3b338cc1ce69ad8d71f54453d8.svg";